<template>
  <div>
    <div class="row"
      v-for="(inputJenis, index) in jenisPemeriksaan"
      :key="index"
    >
      <div class="col-md-11 mt-3">
        <div class="form-row">
          <div class="form-group text-subtitle col-xs-6 col-md-6 col-lg-3">
            <label>Kategori Pemeriksaan Penunjang</label>
            <vue-select-clearable
              class="select_jenis_pemeriksaan"
              :options="options.kategori"
              v-model="inputJenis.selectedKategori"
              placeholder="Pilih Kategori Pemeriksaan"
              @input="setInputJenis()"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.label }}
              </template>
            </vue-select-clearable>
          </div>
          <div class="form-group text-subtitle col-xs-6 col-md-6 col-lg-3">
            <label>Jenis Pemeriksaan Penunjang</label>
            <vue-select-clearable
              class="select_jenis_pemeriksaan"
              :options="options[inputJenis.selectedKategori && inputJenis.selectedKategori.toLowerCase().replace(/ /g,'_')]"
              v-model="inputJenis.selectedJenis"
              placeholder="Pilih Jenis Pemeriksaan"
              @input="handleSelectedJenis(index)"
              :disabled="!checkValueData(inputJenis.selectedKategori)"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.label }}
              </template>
            </vue-select-clearable>
          </div>
          <div
            v-if="checkJenisLainnya(index)"
            class="form-group text-subtitle col-xs-6 col-md-6 col-lg-3"
          >
            <label>Nama Pemeriksaan Penunjang</label>
            <input
              placeholder="Tulis Nama Pemeriksaan"
              type="text"
              class="form-control"
              :value="inputJenis.jenis_lain"
              @input="
                event => {
                  inputJenis.jenis_lain = event.target.value;
                  setInputJenis();
                }
              "
            />
          </div>
          <div
            :class="
              !checkJenisLainnya(index) && checkValueData(inputJenis.selectedKategori) && inputJenis.selectedKategori.toLowerCase().includes('radiologi')
              ? 'col-lg-2' : 'col-lg-3'"
            class="form-group text-subtitle col-xs-6 col-md-6"
          >
            <label>Tanggal Pemeriksaan</label>
            <DatePickerX
              v-model="inputJenis.tanggal"
              :popover="{
                placement: 'auto',
                visibility: 'click',
                positionFixed: true
              }"
              :input-props="{
                placeholder: 'Pilih Tanggal Pemeriksaan',
                readonly: true
              }"
              :masks="{ input: 'DD-MM-YYYY' }"
              :minDate="minDatePemeriksaan()"
              :maxDate="new Date()"
              :is-required="true"
              :disabled="!checkValueData(inputJenis.selectedJenis)"
            >
              <template v-slot="{ inputValue, togglePopover }">
                <b-form-input
                  type="text"
                  placeholder="Pilih tanggal Pemeriksaan"
                  :value="inputValue"
                  @click="togglePopover()"
                  @keypress.enter="togglePopover()"
                  @keypress="onKeyInputTanggal($event)"
                  @input="inputTanggal($event, index, togglePopover)"
                  :disabled="!checkValueData(inputJenis.selectedJenis)"
                ></b-form-input>
                <font-awesome-icon
                  icon="calendar"
                  class="cal-pos"
                />
              </template>
            </DatePickerX>
          </div>
          <div
            v-if="checkValueData(inputJenis.selectedKategori) && inputJenis.selectedKategori.toLowerCase().includes('radiologi')"
            :class="
              checkJenisLainnya(index) && checkValueData(inputJenis.selectedKategori) && inputJenis.selectedKategori.toLowerCase().includes('radiologi')
              ? 'col-lg-6' : 'col-lg-4'
            "
            class="form-group text-subtitle col-xs-6 col-md-6 col-lg-4"
          >
            <label class="ml-1">Unggah Hasil Pemeriksaan Penunjang</label>
            <div
              id="upload-box-jenis"
              class="row justify-content-md-center"
              v-if="inputJenis.file && inputJenis.file.length == 0"
            >
              <template>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="triggerAction(index)"
                  :disabled="!checkValueData(inputJenis.selectedJenis)"
                >
                  <span class="btn-wrapper--icon">
                    <font-awesome-icon icon="camera" />
                  </span>
                  <span class="btn-wrapper--label">Dari Kamera</span>
                </b-button>
                <input
                  type="file"
                  accept="image/*"
                  capture="environment"
                  style="display:none"
                  :ref="'cameraInput-' + index"
                  @change="onImageCapturedIndex($event, index)"
                  :disabled="!checkValueData(inputJenis.selectedJenis)"
                />
                <div class="col-md-auto">Atau</div>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="triggerFileInput(index)"
                  :disabled="!checkValueData(inputJenis.selectedJenis)"
                >
                  <span class="btn-wrapper--icon">
                    <font-awesome-icon icon="folder" />
                  </span>
                  <span class="btn-wrapper--label">Cari File</span>
                </b-button>
                <input
                  type="file"
                  @change="onFileSelectedIndex($event, index)"
                  @click="resetFileInputIndex(index)"
                  style="display:none"
                  :ref="'fileInput-' + index"
                  :disabled="!checkValueData(inputJenis.selectedJenis)"
                />
              </template>
            </div>
            <div
              v-else
              v-for="(item, i) in inputJenis.file"
              :key="`file_${i}`"
              :class="`row file-upload-index file-upload-index-${index}`"
            >
              <div class="col-md-4">
                <label class="text-break">{{ item.name }}</label>
              </div>
              <div class="col-md-2">
                <label>{{ Math.round(item.size / 1000) }} KB</label>
              </div>
              <div class="col-md-3">
                <b-progress :max="100">
                  <b-progress-bar
                    :value="fileProgress[item.name]"
                    :label="`${Math.round(fileProgress[item.name])}%`"
                  ></b-progress-bar>
                </b-progress>
              </div>
              <div class="col-md-3">
                <div class="row d-flex justify-content-end mr-1">
                  <a @click.prevent="donwloadImage(item)" v-if="item.from_api">
                    <font-awesome-icon
                      icon="download"
                      class="font-size-lg grow icon"
                      style="margin-right:10px"
                    />
                  </a>
                  <a v-else @click="donwloadImage(item)">
                    <font-awesome-icon
                      icon="download"
                      class="font-size-lg grow icon"
                      style="margin-right:10px"
                    />
                  </a>
                  <font-awesome-icon
                    icon="eye"
                    class="font-size-lg grow icon"
                    style="margin-right:10px"
                    v-if="isShow(item)"
                    @click="readFileIndex(item)"
                  />
                  <font-awesome-icon
                    icon="trash"
                    class="font-size-lg grow icon"
                    @click="removeFileIndex(item, index)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group text-subtitle col-xs-6 col-md-6 col-lg-3">
            <label>Hasil Pemeriksaan</label>
            <input
              placeholder="Tulis Hasil Pemeriksaan"
              type="text"
              class="form-control"
              :value="inputJenis.hasil"
              @input="
                event => {
                  inputJenis.hasil = event.target.value;
                  setInputJenis();
                }
              "
              :disabled="!checkValueData(inputJenis.selectedJenis)"
            />
          </div>
        </div>
      </div>
      <div class="col-md-1 mt-5 p-0">
        <div class="form-group">
          <b-button
            v-if="jenisPemeriksaan.length > 1"
            variant="danger"
            style="padding: 0.1rem 0.3rem;border-radius: 100%;"
            @click="removeJenis(index)"
            
          >
            <font-awesome-icon icon="minus" />
          </b-button>
          <b-button
            v-if="(jenisPemeriksaan.length-1) == index"
            variant="first"
            style="padding: 0.1rem 0.3rem;border-radius: 100%;background-color: #01a8e5;border-color: transparent;margin-left: 0.3rem;"
            @click="addInputJenis()"
          >
            <font-awesome-icon icon="plus" />
          </b-button>
        </div>
      </div>
    </div>

    <b-row class="mt-4">
      <b-col cols="6">
        <label class="text-subtitle">* Unggah Hasil Pemeriksaan Penunjang (maks. 5 file)</label>
        <div id="upload-box" class="row justify-content-md-center" :style="uploadBoxPadding">
          <template v-if="!activateCamera">
            <b-button variant="dark" @click="determineAction">
              <span class="btn-wrapper--icon">
                <font-awesome-icon icon="camera" />
              </span>
              <span class="btn-wrapper--label">Dari Kamera</span>
            </b-button>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              style="display:none"
              ref="cameraInput"
              @change="onImageCaptured"
            />
            <div class="col-md-auto">Atau</div>
            <b-button variant="dark" @click="$refs.fileInput.click()">
              <span class="btn-wrapper--icon">
                <font-awesome-icon icon="folder" />
              </span>
              <span class="btn-wrapper--label">Cari File</span>
            </b-button>
            <input
              type="file"
              @change="onFileSelected"
              @click="resetFileInput"
              style="display:none"
              ref="fileInput"
              multiple="multiple"
            />
          </template>
          <template v-else>
            <web-cam
              class="my-3"
              ref="webcam"
              @started="onStarted"
              @stopped="onStopped"
              @error="onError"
              @cameras="onCameras"
              @camera-change="onCameraChange"
              :device-id="deviceId"
            />
            <b-button variant="dark" @click="onCapture">
              <span class="btn-wrapper--icon">
                <font-awesome-icon icon="camera" />
              </span>
              <span class="btn-wrapper--label text-capitalize">ambil gambar</span>
            </b-button>
          </template>
        </div>
        <label style="font-size: 12px;font-style:italic;">Format yang digunakan: jpeg, jpg, png, pdf, doc, excel maks. 2MB.</label>
      </b-col>

      <b-col cols="6" class="pr-0">
        <b-row>
          <b-col cols="12" class="row">
            <b-col cols="3" class="text-subtitle pr-0">
              <label>Keterangan:</label>
            </b-col>
            <b-col cols="9" class="float-right pen-isMobile">
              <div class="row d-flex justify-content-end mr-2">
                <div class="mt-2">
                  <span @click="penColor('blue');isColorActive = 'blue'" class="dot grow" style="background-color: blue;"
                    :class="{ color_active: isColorActive === 'blue' }"></span>
                  <span @click="penColor('red');isColorActive = 'red'" class="dot grow" style="background-color: red;"
                    :class="{ color_active: isColorActive === 'red' }"></span>
                  <span @click="penColor('#54c756');isColorActive = 'green'" class="dot grow"
                    style="background-color: #54c756;" :class="{ color_active: isColorActive === 'green' }"></span>
                  <span @click="penColor('#555');isColorActive = 'black'" class="dot grow" style="background-color: #555;"
                    :class="{ color_active: isColorActive === 'black' }"></span>
                  <span @click="penColor('orange');isColorActive = 'yellow'" class="dot grow"
                    style="background-color: orange;" :class="{ color_active: isColorActive === 'yellow' }"></span>
                </div>
                <font-awesome-icon
                  icon="eraser"
                  class="font-size-xl m-2 grow icon"
                  v-on:click="setDrawPostData('eraser');"
                  v-show="!isHidden"
                  :class="{ active_tool: isActive === 'eraser' }" />
                <font-awesome-icon
                  icon="pen-alt"
                  class="font-size-xl m-2 grow icon"
                  v-on:click="setDrawPostData('pen');"
                  :class="{ active_tool: isActive === 'pen' }" />
                <font-awesome-icon
                  icon="keyboard"
                  class="font-size-xl m-2 grow icon"
                  v-on:click="setDrawPostData('keyboard');"
                    :class="{ active_tool: isActive === 'keyboard' }" />
              </div>
              <div class="row d-flex justify-content-end mr-2">
                <input type="range" class="custom-range pen-width" min="1" max="50" v-model.number="penWidth" />
              </div>
            </b-col>
          </b-col>
          <b-col cols="12" v-show="!isHidden">
            <canvas
              id="pemeriksaan_penunjang-canvas"
              ref="canvas"
              @mousedown="handleMousedown"
              @mouseup="handleMouseup"
              @mousemove="handleMousemove"
              @touchstart="handleTouchstart"
              @touchend="handleTouchend"
              @touchmove="handleTouchmove"
              :width="canvasWidth"
              :height="canvasHeight"
            >
              Your browser does not support the HTML 5 Canvas.
            </canvas>
          </b-col>
          <b-col cols="2" v-show="!isHidden">
            <b-button @click="clear" variant="warning" size="sm" class="m-1">Clear</b-button>
          </b-col>

          <b-col cols="12" v-show="isHidden">
            <Editor
              :height="contentHeight"
              :width="contentWidth"
              class="form-penunjang"
              :editorContent="penunjang"
              v-on:update-content="updateContent"
            />
          </b-col>
          <b-col cols="12" v-show="!isHidden">
            <div id="img_pemeriksaan_penunjang"></div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-4" v-if="selectedFiles.length > 0">
      <b-col cols="6">
        <label>Hasil Pemeriksaan Penunjang</label>
      </b-col>
      <b-col cols="12">
        <div
          v-for="(item, index) in selectedFiles"
          :key="item.index"
          class="row file-upload"
        >
          <div class="col-md-4">
            <label class="text-break">{{ item.name }}</label>
          </div>
          <div class="col-md-2">
            <label>{{ item.size / 1000 }} KB</label>
          </div>
          <div class="col-md-3">
            <b-progress :max="100">
              <b-progress-bar
                :value="fileProgress[item.name]"
                :label="`${Math.round(fileProgress[item.name])}%`"
              ></b-progress-bar>
            </b-progress>
          </div>
          <div class="col-md-3">
            <div class="row d-flex justify-content-end mr-2">
              <!-- :href="item.url" -->
              <a @click.prevent="donwloadImage(item)" v-if="item.from_api">
                <font-awesome-icon
                  icon="download"
                  class="font-size-xl grow icon"
                  style="margin-right:20px"
                />
              </a>
              <a v-else @click="downloadFile(item)">
                <font-awesome-icon
                  icon="download"
                  class="font-size-xl grow icon"
                  style="margin-right:20px"
                />
              </a>
              <font-awesome-icon
                icon="eye"
                class="font-size-xl grow icon"
                style="margin-right:20px"
                v-if="isShow(item)"
                @click="readFile(item)"
              />
              <font-awesome-icon
                icon="trash"
                class="font-size-xl grow icon"
                @click="removeFile(item, index)"
              />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Modal Camera -->
    <b-modal
      ref="modal-camera"
      size="lg"
      hide-header
      hide-footer
      :no-close-on-backdrop="true"
    >
      <b-row>
        <b-col sm="10 px-4">
          <ol class="breadcrumb font-size-xs p-0">
            <li class="breadcrumb-item font-weight-bold text-primary">
              Rekam Medis
            </li>
            <li class="breadcrumb-item active">Camera</li>
          </ol>
          <label class="display-4 mb-3 font-weight-bold">Camera</label>
        </b-col>
        <b-col sm="2" class="text-right">
          <a @click.prevent="closeModal" class="pointer">
            Close
          </a>
        </b-col>
      </b-row>
      <b-card class="card-shadowless card-info">
        <b-row class="">
          <b-col sm="12" class="text-center" v-if="activeCamera">
            <web-cam
              class="my-3"
              ref="webcamera"
              @started="onStarted"
              @stopped="onStopped"
              @error="onError"
              @cameras="onCameras"
              @camera-change="onCameraChange"
              :device-id="deviceId"
            />
            <b-button variant="dark" @click="onCaptureIndex">
              <span class="btn-wrapper--icon">
                <font-awesome-icon icon="camera" />
              </span>
              <span class="btn-wrapper--label text-capitalize">ambil gambar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
    <!-- End Modal Camera -->

  </div>
</template>
  
<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import { ImageCompressor } from 'compressor-img';
  import { WebCam } from 'vue-web-cam';
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { faPlus, faMinus} from '@fortawesome/free-solid-svg-icons';
  library.add(faPlus, faMinus);
  
  export default {
    name: 'ObjectivePemeriksaanPenunjang',
    components: {
      WebCam,
      Editor: () => import('./Editor.vue'),
      'vue-select-clearable': () => import('@/components/VueSelectClearable.vue'),
      DatePickerX: () => import('v-calendar/lib/components/date-picker.umd'),
    },
    data() {
      return {
        isDrawing: false,
        isHidden: true,
        drawing: false,
        mousePos: { x: 0, y: 0 },
        lastPos: { x: 0, y: 0 },
        ctx: null,
        isLoading: false,
        isPen: false,
        isActive: 'keyboard',
        isColorActive: 'black',
        penWidth: 2,
        selectedFiles: [],
        fileProgress: [],
        promises: [],
        fileReaderPromises: [],
        uploadedFiles: [],
        supportedFiles: ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx'],
        camera: null,
        devices: [],
        deviceId: null,
        activateCamera: false,
        ediRekamMedis: {},
        penunjang: null,
        imgPenunjang: null,
        jenisPemeriksaan: [
          {
            selectedKategori: null,
            selectedJenis: null,
            tanggal: null,
            hasil: null,
            jenis_lain: null,
            file: [],
          }
        ],
        selectedFilesIndex: [],
        uploadedFilesIndex: [],
        supportedFilesIndex: ['png', 'jpg', 'jpeg'],
        fileReaderPromisesIndex: [],
        activeCamera: false,
        webCamera: '',
        contentWidth: 675,
        contentHeight: 165,
        canvasWidth: 675,
        canvasHeight: 195,
        uploadBoxPadding: 'padding: 185px 25px;',
        options: {
          kategori: [],
          laboratorium: [],
          penunjang_lainnya: [],
          radiologi: [],
        },
      };
    },
    computed: {
      ...mapState(['sidebar']),
      ...mapGetters('sidebar', ['collapsed', 'collapsedMobile', 'orientation']),
      ...mapGetters(['getKlinikId', 'canvas_pemeriksaan_penunjang', 'trx']),
      canvas() {
        return this.$refs.canvas;
      },
      selectedJenis() {
        return this.jenisPemeriksaan
          .map(item => item.selectedJenis ? item.selectedJenis.value : null)
          .filter(item => item !== null);
      },
    },
    watch: {
      camera: function(id) {
        this.deviceId = id;
      },
      devices: function() {
        // Once we have a list select the first one
        const [first, ...tail] = this.devices;
        if (first) {
          this.camera = first.deviceId;
          this.deviceId = first.deviceId;
        }
      },
      imgPenunjang() {
        this.imgPenunjangChanged();
      },
      collapsed() {
        setTimeout(() => {
          this.resizeWidth(this.collapsed);
          this.imgPenunjang = this.canvas_pemeriksaan_penunjang ? this.canvas_pemeriksaan_penunjang.toDataURL('image/png') : null;
        }, 500);
      },
      collapsedMobile() {
        setTimeout(() => {
          this.resizeWidth(this.collapsedMobile);
          this.imgPenunjang = this.canvas_pemeriksaan_penunjang ? this.canvas_pemeriksaan_penunjang.toDataURL('image/png') : null;
        }, 500);
      },
      orientation() {
        setTimeout(() => {
          this.resizeWidth(this.collapsedMobile);
          this.imgPenunjang = this.canvas_pemeriksaan_penunjang ? this.canvas_pemeriksaan_penunjang.toDataURL('image/png') : null;
        }, 500);
      },
    },
    async mounted() {
      await this.resizeWidth(this.collapsed);
      
      this.getKategoriPemeriksaan();
      this.getJenisPemeriksaan();

      this.ctx = this.canvas.getContext('2d');
      this.ctx.strokeStyle = '#222222';
      this.ctx.lineWidth = this.penWidth;
      this.ctx.lineJoin = 'round';
      this.ctx.lineCap = 'round';
  
      //append data canvas to vuex global state
      this.updateCanvas({ key: 'PEMERIKSAAN_PENUNJANG', value: this.canvas });
      this.updatePostData({ key: 'pemeriksaan_penunjang_is_draw', value: false });
  
      // Get a regular interval for drawing to the screen
      window.requestAnimFrame = (function(callback) {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimaitonFrame ||
          function(callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();
      // Prevent scrolling when touching the canvas
      document.body.addEventListener(
        'touchstart',
        function(e) {
          if (
            e.target == document.getElementById('pemeriksaan_penunjang-canvas')
          ) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchend',
        function(e) {
          if (
            e.target == document.getElementById('pemeriksaan_penunjang-canvas')
          ) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchmove',
        function(e) {
          if (
            e.target == document.getElementById('pemeriksaan_penunjang-canvas')
          ) {
            e.preventDefault();
          }
        },
        false
      );
  
      this.ediRekamMedis = localStorage.getItem('edit_rekam_medis');
      if(this.ediRekamMedis != null) this.setPenunjangData(JSON.parse(this.ediRekamMedis));
    },
    methods: {
      minDatePemeriksaan() {
        if (this.trx && this.trx.waktu_konsultasi) {
          let date = new Date(this.trx.waktu_konsultasi);
          date.setMonth(date.getMonth() - 6);
          return date;
        }
      },
      isShow(d) {
        if(d.name != undefined) {
          const accept = [
            'jpeg', 'jpg', 'png',
            'JPEG', 'JPG', 'PNG',
            'gif', 'pdf',
          ]
          let ext = d.uploaded_name != null ? d.uploaded_name.split('.').pop() : d.name.split('.').pop()
          if(accept.includes(ext)) return true
          else return false
        } else {
          return false
        }
      },
      setPenunjangData(d) {
        if (d.pemeriksaan_penunjang.is_draw) {
          this.penunjang = d.pemeriksaan_penunjang.notes
          if (d.pemeriksaan_penunjang.draw_path != null) {
            this.imgPenunjang = d.pemeriksaan_penunjang.draw_path;
            this.updatePostData({ key: 'pemeriksaan_penunjang_is_draw', value: true });
          }
        } else {
          this.penunjang = d.pemeriksaan_penunjang.notes
        }
        if (
            d.pemeriksaan_penunjang.files != null
            && d.pemeriksaan_penunjang.files != 'null'
          ) {
          const files = JSON.parse(d.pemeriksaan_penunjang.files)
          files.map(item => {
            if (item.name != undefined) {
              this.$set(this.fileProgress, item.name, 100);
              this.selectedFiles.push({
                name: item.name,
                size: item.size,
                file: item.url || item.file,
                url: item.url || item.file,
                from_api: true,
                uploaded_name: item.uploaded_name,
              })
            }
          })
        }

        if (d.pemeriksaan_penunjang_hasil && d.pemeriksaan_penunjang_hasil.length > 0) {
          this.jenisPemeriksaan = d.pemeriksaan_penunjang_hasil.map(pph => {
            let file = pph.file || [];
            return {
              selectedKategori: pph.master.category,
              selectedJenis: {
                ...pph.master,
                value: pph.master.id,
                label: pph.master.name,
              },
              tanggal: new Date(pph.tanggal),
              hasil: pph.hasil,
              jenis_lain: pph.nama,
              file: file.map(f => {
                this.$set(this.fileProgress, f.name, 100);
                return f;
              }),
            }
          });
          this.setInputJenis();
        }
      },
      imgPenunjangChanged() {
        let self = this;
        self.image_url = self.imgPenunjang;
        self.clear();
        self.drawBackground(self.image_url);
      },
      // draw the image
      drawBackground(image_url) {
        let self = this;
        let canvas = document.getElementById('pemeriksaan_penunjang-canvas'),
          ctx = canvas.getContext('2d'),
          img_pemeriksaan_penunjang = document.getElementById('img_pemeriksaan_penunjang');
        let backgroundURL = image_url;
  
        let background = new Image();
        background.crossOrigin = 'Anonymous';
        background.src = backgroundURL;
  
        //remove existing image
        if (img_pemeriksaan_penunjang.hasChildNodes()) {
          img_pemeriksaan_penunjang.innerHTML = '';
        }
  
        background.onload = function() {
          let newSize = { width: self.canvasWidth, height: self.canvasHeight };
          ctx.drawImage(background, 0, 0, newSize.width, newSize.height);
        };
        this.isDrawing = true;
      },
      determineAction() {
        //cek batas upload file
        if (this.selectedFiles.length >= 5) {
          this.$swal({
            type: 'error',
            title: 'File Telah Mencapai Batas Maksimal',
            text: 'Anda hanya bisa mengunggah 5 file dalam 1x visit pasien!'
          });
          return;
        }

        if (this.isMobile()) {
          this.$refs.cameraInput.click();
        } else {
          this.activateCamera = true;
          this.$nextTick(this.onStart);
        }
      },
      onCapture() {
        this.processWebcamImage(this.$refs.webcam.capture());
        this.activateCamera = false;
        this.onStop();
      },
      processWebcamImage(x) {
        fetch(x)
          .then(res => res.blob())
          .then(blob => {
            this.selectedFiles.push({
              name: `webcam_captured_${+new Date()}`,
              file: blob,
              size: blob.size
            })
          })
          .then(this.processUpload);
      },
      onStarted(stream) {},
      onStopped(stream) {},
      onStop() {
        this.$refs.webcam.stop();
      },
      onStart() {
        this.$refs.webcam.start();
      },
      onError(error) {
        this.$swal({
          type: 'error',
          title: 'Camera access denied',
          text: error
        });
      },
      onCameras(cameras) {
        this.devices = cameras;
      },
      onCameraChange(deviceId) {
        this.deviceId = deviceId;
        this.camera = deviceId;
      },
      ...mapActions(['updatePostData', 'updateCanvas']),
      updateContent(content) {
        this.updatePostData({
          key: 'pemeriksaan_penunjang_text',
          value: content
        });
      },
  
      //check is last item on loop
      isLastItem(index) {
        if (index === this.selectedFiles.length - 1) {
          return true;
        }
        return false;
      },
      //convert b64 to blob
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
  
        let byteCharacters = atob(b64Data);
        let byteArrays = [];
  
        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          let slice = byteCharacters.slice(offset, offset + sliceSize);
  
          let byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
  
          let byteArray = new Uint8Array(byteNumbers);
  
          byteArrays.push(byteArray);
        }
  
        let blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      //check image files or not
      isFileImage(file) {
        const acceptedImageTypes = [
          'image/gif',
          'image/jpeg',
          'image/png',
          'image/jpg'
        ];
        return file && acceptedImageTypes.includes(file['type']);
      },
      resetFileInput() {
        const x = this.$refs.fileInput;
        x.value = '';
      },
      //on file selected handler
      async onFileSelected(event) {
        const {
          target: { files }
        } = event;
        this.fileReaderPromises = [];

        if (
          this.selectedFiles.some(x =>
            Object.keys(files)
              .filter(item => item !== 'length')
              .some(item => files[item].name === x.name)
          )
        ) {
          this.$swal({
            type: 'error',
            text: 'Anda tidak bisa memasukkan data yang sama!'
          });
          return false;
        }
  
        let a = document.getElementsByClassName('file-upload');
        if (a.length + event.target.files.length > 5) {
          this.$swal({
            type: 'error',
            title: 'File Telah Mencapai Batas Maksimal',
            text: 'Anda hanya bisa mengunggah 5 file dalam 1x visit pasien!'
          });
          return;
        }
  
        for (let i = 0; i < event.target.files.length; i++) {
          if (i == 5 || this.selectedFiles.length == 5) {
            this.$swal({
              type: 'error',
              title: 'File Telah Mencapai Batas Maksimal',
              text: 'Anda hanya bisa mengunggah 5 file dalam 1x visit pasien!'
            });
            return;
          }
          let file = event.target.files[i];
          let extension = file.name.split('.').pop();
  
          if (this.supportedFiles.includes(extension.toLowerCase())) {
            if (this.isFileImage(file)) {
              this.compressImage(file);
            } else {
              file = { name: file.name, file: file, size: file.size, from_api: false };
              this.selectedFiles.push(file);
            }
          } else {
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text:
                'file ' +
                file.name +
                ' not supported, please upload jpeg, jpg, png, pdf, doc, excel file...'
            });
          }
        }
  
        await Promise.all(this.fileReaderPromises)
          .then(res => {
            res.map(item => {
              this.selectedFiles.push(item);
            });
          })
          .then(this.processUpload);
      },
      async processUpload() {
        if (this.selectedFiles.length > 0) {
          this.selectedFiles.map(item => {
            if (!item.isUploading && !item.from_api) {
              this.prepareUpload(item.name, item.file);
              item.isUploading = true;
            }
          });
        }
  
        try {
          await Promise.all(this.promises).then(res => {
            res.map(item => {
              if (!item.data.status) {
                return this.$swal({
                  type: 'error',
                  title: 'Oops...',
                  text: item.data.message
                }).then(() => {
                });
              } else {
                this.uploadedFiles = res.reduce((unique, item) => {
                  return unique.includes(item.data) ? unique : [...unique, item.data];
                }, []);
              }
            });
          });
        } catch(e) {
        }
  
        if (this.selectedFiles.length > 0) {
          this.selectedFiles.map(item => {
            if (!this.uploadedFiles.find(f => f.name == item.name)) {
              this.uploadedFiles.push(item)
            }
          });
        }
  
        this.updatePostData({
          key: 'pemeriksaan_penunjang',
          value: this.uploadedFiles
        });
      },
      //compress if file images
      compressImage(file) {
        this.fileReaderPromises.push(
          new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onloadend = () => {
              let imageCompressor = new ImageCompressor({
                onSuccess: response => {
                  let ImageURL = response.compressed;
                  let block = ImageURL.split(';');
                  let contentType = block[0].split(':')[1];
                  let realData = block[1].split(',')[1];
                  let blob = this.b64toBlob(realData, contentType);
                  resolve({ name: file.name, file: blob, size: blob.size });
                },
                scale: 70,
                quality: 70,
                originalImage: reader.result
              });
            };
            reader.readAsDataURL(file);
          })
        );
      },
      //prepare formData
      prepareUpload(filename, file) {
        let formData = new FormData();
        formData.append('klinik_id', this.getKlinikId)
        formData.append('file', file);
        formData.append('filename', filename);
  
        this.promises.push(
          this.$axios.post('/upload-cloud', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: progressEvent => {
              let progress = (progressEvent.loaded * 100) / progressEvent.total;
              this.$set(this.fileProgress, filename, progress);
            }
          })
          .then(res => {
            if(res.data.status) this.uploadedFiles.push(res.data)
          })
          .catch(e => {
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: `Gagal mengupload ${filename}`
            })
            .then(() => {
              let rmIndex = this.selectedFiles.map(item => {
                return item.name;
              }).indexOf(filename);
              this.selectedFiles.splice(rmIndex, 1);            
            })
          })
        );
      },
      //camera handler
      onImageCaptured(event) {
        //handle image from camera or from disk here...
        this.onFileSelected(event);
      },
      async donwloadImage(item) {
        const result = await this.toDataURL(item.url);

        if (result && result.fallback) {
          const a = document.createElement('a');
          a.href = result.url;
          a.download = item.name;
          a.target = '_blank';
          a.rel = "noopener";
          document.body.appendChild(a);
          a.click();
          a.remove();
        } else {
          const a = document.createElement("a");
          a.href = result;
          a.download = item.name;
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      },
      async toDataURL(url) {
        try {
          const res = await fetch(url);
          if (!res.ok) throw new Error("Failed to fetch");

          const blob = await res.blob();
          return URL.createObjectURL(blob);
        } catch (err) {
          return { fallback: true, url };
        }
      },
      //download selected file
      downloadFile(item) {
        if (item.from_api == true){
          window.open(item.url || item.file, '_blank');
        }else{
          const data = window.URL.createObjectURL(item.file);
          const link = document.createElement('a');
          link.href = data;
          link.download = item.name;
          link.click();
          setTimeout(function() {
            window.URL.revokeObjectURL(data);
          }, 100);
        }
      },
      async downloadFileIndex(item) {
        let blobUrl = null;
        if (item.from_api == true || item.url.includes('http')) {
          const response = await fetch(item.url);
          if (!response.ok) return;

          const blob = await response.blob();
          blobUrl = window.URL.createObjectURL(blob)
        } else {
          blobUrl = window.URL.createObjectURL(item.url);
        }

        if (blobUrl) {
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = item.name;
          link.click();
          setTimeout(function() {
            window.URL.revokeObjectURL(blobUrl);
          }, 100);
        }
      },
      //view selected file
      readFile(item) {
        if (item.from_api == true) {
          window.open(item.file)
        } else {
          const data = window.URL.createObjectURL(item.file)
          window.open(data)
        }
      },
      readFileIndex(item) {
        if (item.from_api == true || item.url.includes('http')) {
          window.open(item.url)
        } else {
          const data = window.URL.createObjectURL(item.url)
          window.open(data)
        }
      },
      //remove selected file
      removeFile(file, index) {
        this.selectedFiles.splice(index, 1);
        this.promises.splice(index, 1);
        let filename = file.name;
  
        if(file.from_api == true) {        
          this.$axios.post('/delete-cloud', {
            filenames: [file.uploaded_name]
          });
  
          this.updatePostData({
            key: 'pemeriksaan_penunjang',
            value: this.selectedFiles
          });
        } else {
          let removeIndex = this.uploadedFiles
            .map(item => {
              return item.name;
            })
            .indexOf(filename);
  
          const doDelete = this.$axios.post('/delete-cloud', {
            filenames: [this.uploadedFiles[removeIndex].uploaded_name]
          });
  
          doDelete.then(res => {
            this.uploadedFiles.splice(removeIndex, 1);
  
            this.updatePostData({
              key: 'pemeriksaan_penunjang',
              value: this.uploadedFiles
            });
          });
        }
      },
  
      handleMousedown(e) {
        this.lastPos = this.getMousePos(e);
        this.ctx.lineWidth = this.penWidth;
        this.drawing = true;
      },
      handleMouseup(e) {
        this.drawing = false;
      },
      handleMousemove(e) {
        this.mousePos = this.getMousePos(e);
        if (this.drawing) {
          this.ctx.beginPath();
          if (this.isPen) {
            this.ctx.globalCompositeOperation = 'source-over';
            this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
            this.ctx.lineTo(this.mousePos.x, this.mousePos.y);
            this.ctx.stroke();
          } else {
            this.ctx.globalCompositeOperation = 'destination-out';
            this.ctx.arc(
              this.mousePos.x,
              this.mousePos.y,
              this.penWidth,
              0,
              Math.PI * 2,
              false
            );
            this.ctx.fill();
          }
          this.lastPos = this.mousePos;
        }
      },
      handleTouchstart(event) {
        this.mousePos = this.getTouchPos(event);
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousedown', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchend(event) {
        let mouseEvent = new MouseEvent('mouseup', {});
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchmove(event) {
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousemove', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      getMousePos(mouseEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top
        };
      },
      getTouchPos(touchEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top
        };
      },
      penColor(color) {
        this.ctx.strokeStyle = color;
      },
      clear() {
        this.canvas.width = this.canvas.width;
        this.isDrawing = false;
        this.isColorActive = 'black';
      },
      setDrawPostData(type) {
        if (type == 'pen') {
          this.isPen = true;
          this.isHidden = false;
          this.isDrawing = true;
        } else if (type == 'eraser') {
          this.isPen = false;
          this.isHidden = false;
        } else {
          this.isPen = false;
          this.isHidden = true;
        }
        this.isActive = type;
        this.updatePostData({ key: 'pemeriksaan_penunjang_is_draw', value: this.isDrawing });
      },
      addInputJenis() {
        const { jenisPemeriksaan } = this;
        const lastIndex = jenisPemeriksaan[jenisPemeriksaan.length - 1];
        const x = Object.keys(lastIndex);

        const tmp = x.reduce((obj, key) => {
          if (key === 'id') {
            obj[key] = jenisPemeriksaan.length + 1;
          } else if (key == 'qty') {
            obj[key] = 1;
          } else if (key == 'file') {
            obj[key] = [];
          } else {
            obj[key] = null;
          }
          return obj;
        }, {});
        this.jenisPemeriksaan = [...jenisPemeriksaan, tmp];
      },
      removeJenis(index) {
        const { jenisPemeriksaan } = this;
        if (jenisPemeriksaan.length > 1) {
          const tmpJenis = jenisPemeriksaan;
          const tmp = tmpJenis
            .slice(0, index)
            .concat(tmpJenis.slice(index + 1, tmpJenis.length));
          this.jenisPemeriksaan = [...tmp];
          this.setInputJenis()
        }
      },
      setInputJenis() {
        this.updatePostData({
          key: 'jenis_pemeriksaan',
          value: this.jenisPemeriksaan
        });
      },
      handleSelectedJenis(idx) {
        if (this.jenisPemeriksaan[idx].selectedJenis && this.jenisPemeriksaan[idx].selectedJenis.label.toLowerCase().includes('radiologi')) {
          this.jenisPemeriksaan[idx].file = [];
        }
        this.jenisPemeriksaan[idx].tanggal = null;
        this.jenisPemeriksaan[idx].hasil = null;
        this.jenisPemeriksaan[idx].jenis_lain = null;

        this.setInputJenis();
      },
      triggerFileInput(index) {
        this.$refs[`fileInput-${index}`][0].click();
      },
      triggerAction(index) {
        this.$refs['modal-camera'].show();
        this.webCamera = `start_${index}`;
        this.activeCamera = true;
        this.$nextTick(this.onStartIndex(index))
      },
      onStartIndex(index) {
        if (this.$refs.webcamera) {
          this.$refs.webcamera.start();
        }   
      },
      onStopIndex() {
        this.$refs.webcamera.stop();
        this.webCamera = '';
      },
      onCaptureIndex() {
        this.$refs['modal-camera'].hide()
        this.processWebcamImageIndex(this.$refs.webcamera.capture());
        this.activeCamera = false;
        this.onStopIndex();
      },
      closeModal() {
        this.$refs['modal-camera'].hide()
        this.activeCamera = false;
        this.webCamera = '';
      },
      processWebcamImageIndex(x) {
        let idx = this.webCamera.replace('start_','');
        fetch(x)
          .then(res => res.blob())
          .then(blob => {
            this.jenisPemeriksaan[idx].file = Array(1).fill({
              name: `jenis_penunjang_${+new Date()}`,
              file: blob,
              size: blob.size
            });
            this.processUploadIndex(idx);
          })
      },
      async processUploadIndex(idx) {
        if (this.jenisPemeriksaan[idx].file && this.jenisPemeriksaan[idx].file.length > 0) {
          this.jenisPemeriksaan[idx].file.map(item => {
            if (!item.isUploading && !item.from_api) {
              this.prepareUploadIndex(item.name, item.file, idx);
              item.isUploading = true;
            }
          });
        }
  
        try {
          await Promise.all(this.promises).then(res => {
            res.map((item, index) => {
              if (!item.data.status) {
                return this.$swal({
                  type: 'error',
                  title: 'Oops...',
                  text: item.data.message
                }).then(() => {
                });
              } else {
                this.jenisPemeriksaan[idx].file = res.reduce((unique, item) => {
                  return unique.includes(item.data) ? unique : [...unique, item.data];
                }, []);
              }
            });
          });
        } catch(e) {
        }
        this.setInputJenis();
  
        // if (this.jenisPemeriksaan[idx].file && this.jenisPemeriksaan[idx].file.length > 0) {
        //   this.jenisPemeriksaan[idx].file.map(item => {
        //     if (item.from_api) {
        //       this.uploadedFilesIndex.push(item)
        //     }
        //   });
        // }
      },
      prepareUploadIndex(filename, file, idx) {
        let formData = new FormData();
        formData.append('klinik_id', this.getKlinikId)
        formData.append('file', file);
        formData.append('filename', filename);

        this.promises.push(
          this.$axios.post('/upload-cloud', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: progressEvent => {
              let progress = (progressEvent.loaded * 100) / progressEvent.total;
              this.$set(this.fileProgress, filename, progress);
            }
          })
          .then(res => {
            if (res.data.status) this.jenisPemeriksaan[idx].file = [res.data];
          })
          .catch(e => {
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: `Gagal mengupload ${filename}`
            })
            .then(() => {
              this.jenisPemeriksaan[idx].file = [];            
            })
          })
        );
      },
      async onFileSelectedIndex(event, idx) {
        const {
          target: { files }
        } = event;
        this.fileReaderPromisesIndex = [];
  
        if (
          this.jenisPemeriksaan[idx].file.some(x =>
            Object.keys(files)
              .filter(item => item !== 'length')
              .some(item => files[item].name === x.name)
          )
        ) {
          this.$swal({
            type: 'error',
            text: 'Anda tidak bisa memasukkan data yang sama!'
          });
          return false;
        }
  
        let a = document.getElementsByClassName(`file-upload-index-${idx}`);
        if (a.length + event.target.files.length > 1) {
          this.$swal({
            type: 'error',
            title: 'File Telah Mencapai Batas Maksimal',
            text: 'Anda hanya bisa mengunggah 1 file'
          });
          return;
        }
  
        for (let i = 0; i < event.target.files.length; i++) {
          if (i == 1 || this.jenisPemeriksaan[idx].file.length == 1) {
            this.$swal({
              type: 'error',
              title: 'File Telah Mencapai Batas Maksimal',
              text: 'Anda hanya bisa mengunggah 1 file'
            });
            return;
          }
          let file = event.target.files[i];
          let extension = file.name.split('.').pop();
  
          if (this.supportedFilesIndex.includes(extension.toLowerCase())) {
            if (this.isFileImage(file)) {
              this.compressImageIndex(file);
            } else {
              file = { name: file.name, file: file, size: file.size, from_api: false };
              this.jenisPemeriksaan[idx].file.push(file);
            }
          } else {
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text:
                'file ' +
                file.name +
                ' not supported, please upload jpeg, jpg, png file...'
            });
          }
        }
  
        await Promise.all(this.fileReaderPromisesIndex)
          .then(res => {
            this.jenisPemeriksaan[idx].file = res;
            this.processUploadIndex(idx);
          });
      },
      resetFileInputIndex(index) {
        const x = this.$refs[`fileInput-${index}`][0];
        x.value = '';
      },
      removeFileIndex(file, index) {  
        if (file.from_api == true) {        
          const doDelete = this.$axios.post('/delete-cloud', {
            filenames: [file.uploaded_name]
          });

          doDelete.then(res => {
            this.jenisPemeriksaan[index].file = [];
          });
        } else {
          const doDelete = this.$axios.post('/delete-cloud', {
            filenames: [file.uploaded_name]
          });
  
          doDelete.then(res => {
            this.jenisPemeriksaan[index].file = [];
          });
        }
      },
      compressImageIndex(file) {
        this.fileReaderPromisesIndex.push(
          new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onloadend = () => {
              let imageCompressor = new ImageCompressor({
                onSuccess: response => {
                  let ImageURL = response.compressed;
                  let block = ImageURL.split(';');
                  let contentType = block[0].split(':')[1];
                  let realData = block[1].split(',')[1];
                  let blob = this.b64toBlob(realData, contentType);
                  resolve({ name: file.name, file: blob, size: blob.size });
                },
                scale: 70,
                quality: 70,
                originalImage: reader.result
              });
            };
            reader.readAsDataURL(file);
          })
        );
      },
      onImageCapturedIndex(event, index) {
        this.onFileSelectedIndex(event, index);
      },
      resizeWidth(collapsed = false) {
        let elRM = document.getElementById('rekam_medis_klinik');

        let w = elRM.offsetWidth;
        let x = 1;

        if (w > 1400) x = 2.335;
        else if (collapsed) {
          if (this.orientation == 'portrait') x = 2.85;
          else {
            if (w < 1024) x = 2.9;
            else x = 2.55;
          }
        } else {
          if (this.orientation == 'portrait') x = 2.816;
          else {
            if (w < 750) x = 2.84;
            else if (w < 1024) x = 2.445;
            else x = 1.964;
          }
        }

        this.canvasWidth = this.contentWidth = w / x;
        this.canvasHeight = this.canvasWidth * 0.5625;
        this.contentHeight = this.canvasHeight * 0.9;
        this.uploadBoxPadding = `padding: ${this.canvasWidth/4.1}px 25px;`
      },
      async getKategoriPemeriksaan() {
        try {
          const res = await this.$axios.get(`pemeriksaan-penunjang/category?klinik_id=${this.getKlinikId}`);
          const { data } = res.data;

          this.options.kategori = data;
        } catch (error) {}
      },
      async getJenisPemeriksaan() {
        try {
          const res = await this.$axios.get(`pemeriksaan-penunjang?klinik_id=${this.getKlinikId}&category=all`);
          const { data } = res.data;

          if (data.hasOwnProperty('laboratorium')) this.options.laboratorium = data.laboratorium;
          if (data.hasOwnProperty('penunjang_lainnya')) this.options.penunjang_lainnya = data.penunjang_lainnya;
          if (data.hasOwnProperty('radiologi')) this.options.radiologi = data.radiologi;
        } catch (error) {}
      },
      onKeyInputTanggal($event) {
        let evt = $event;
        evt = evt ? evt : window.event;
        let charCode = evt.which ? evt.which : evt.keyCode;

        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46 && charCode !== 45
        ) {
          evt.preventDefault();
        }
      },
      inputTanggal(value, idx, togglePopover) {
        let val = value;
        if (!val) return;

        if (val instanceof Date) val = moment(val).format('DD-MM-YYYY') + '';

        const regexPeriod1 = /^\d{2}-\d{2}-\d{4}$/;
        const regexPeriod2 = /^\d{4}-\d{2}-\d{2}$/;
        let period = '',
          periodDate = '';

        if (val.match(regexPeriod1)) {
          period = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
        } else if (val.match(regexPeriod2)) {
          period = moment(val, 'YYYY-MM-DD').format('YYYY-MM-DD');
        } else {        
          console.warn('Format Tanggal Lahir Harus DD-MM-YYYY');
          return;
        }

        periodDate = moment(period, 'YYYY-MM-DD');
        if (periodDate.isValid()) {
          this.jenisPemeriksaan[idx].tanggal = new Date(period);
          togglePopover();
          this.setInputJenis();
        }
      },
      checkJenisLainnya(idx) {
        let result = false;
        if (this.jenisPemeriksaan[idx] && this.jenisPemeriksaan[idx].selectedJenis) {
          if (this.jenisPemeriksaan[idx].selectedJenis.label.toLowerCase().includes('lainnya')) result = true;
        }
        return result;
      },
    },
  };
</script>
  
<style scoped>  
  #pemeriksaan_penunjang-canvas {
    touch-action: none;
  }

  #upload-box {
    border: 1px solid rgb(212, 212, 212);
    border-style: dashed;
    margin: 10px;
    border-radius: 5px;
  }

  #upload-box-jenis {
    padding: 10px;
    border: 1px solid rgb(212, 212, 212);
    border-style: solid;
    margin-left: 2px;
    margin-right: 2px;
    border-radius: 5px;
  }

  .file-upload {
    padding: 25px;
    border: 1px solid rgb(212, 212, 212);
    background-color: rgb(250, 249, 245);
    margin: 10px;
  }

  .file-upload-index {
    padding: 5px;
    border: 1px solid rgb(212, 212, 212);
    border-radius: 5px;
    margin-left: 2px;
    margin-right: 2px;
  }
</style>

<style>
  .select_jenis_pemeriksaan
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
    color: #d1d2db !important;
  }
  .pen-width {
    width: 125px !important;
  }
  .form-penunjang .quill-editor .ql-toolbar {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .form-penunjang .quill-editor .ql-container {
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .form-penunjang .quill-editor .ql-toolbar {
    zoom: 75%;
  }
  .form-penunjang .quill-editor .ql-container {
    color: #505050;
    font-size: 14px;
  }
  @media screen and (max-width: 1400px) {
    .form-penunjang .quill-editor .ql-toolbar {
      zoom: 70%;
    }
    .form-penunjang .quill-editor .ql-container {
      color: #505050;
      font-size: 12px;
    }
  }
  @media screen and (max-width: 1024px) {
    .form-penunjang .quill-editor .ql-toolbar {
      zoom: 60%;
    }
    .form-penunjang .quill-editor .ql-container {
      color: #505050;
      font-size: 10px;
    }
  }
  .cal-pos {
    float: right !important;
    position: absolute;
    right: 15px;
    top: 42px;
    color: gray;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  